import React from 'react';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import FavoriteIcon from 'core/modules/FavoriteIcon/FavoriteIcon';
import MerchantRebateV2 from 'core/modules/MerchantRebateV2/MerchantRebateV2';
import ExtraRewardsPill from 'core/modules/ExtraRewardsPill/ExtraRewardsPill';
import OfferInfo from './components/OfferInfo/OfferInfo';

import './DynamicMerchant.scss';

function DynamicMerchant({
  placement, shouldShowOfferInfo = false, logoTreatment, gaViewType, customClassName, extraLabel,
}) {
  const {
    assets: {
      _120x60, imageAlternateText,
    },
    merchant: {
      id, name, rebate, offersCount,
    },
  } = placement;

  return (
    <div className="mn_dynamicMerchantWrap">
      <div
        className={`mn_dynamicMerchant ${customClassName}`}
        data-logo-treatment={logoTreatment}
        data-view-type={gaViewType}
        data-merchant-name={name}
      >
        <FavoriteIcon merchantId={id} merchantName={name} />
        <a
          href={`/me____.htm?gmid=${id}`}
          title={`Opens merchant detail page for ${name}`}
          className="mn_dynamicMerchantLink"
        >
          <div className="mn_merchantInfoWrap">
            <img className="mn_dynamicMerchantImage" src={_120x60} alt={imageAlternateText} />
            <OfferInfo shouldShowOfferInfo={shouldShowOfferInfo} offersCount={offersCount} />
          </div>
          <div className="mn_merchantRebateWrap" data-test="dynamic-merchant-rebate">
            <ExtraRewardsPill rebate={rebate} label={extraLabel} />
            <MerchantRebateV2 {...rebate} hideRebatePrefix hideElevationCurrency />
          </div>
        </a>
      </div>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><DynamicMerchant {...props} /></ComponentErrorBoundary>;
